import { defineStore } from 'pinia';

export const useWindowStore = defineStore('window', {
  state: () => ({
    windowHeight: 0,
    windowWidth: 0,
  }),

  actions: {},
});
